<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/zhtsgbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'阅读推广与图书漂流中心'"></detailBread>
         <div class="container">
            <div class="page-title">
                阅读推广与图书漂流中心
            </div>
            <div class="page-content">
                <video src="../../../static/images/ydtg.mp4" width="100%" controls="controls">
                    当前浏览器不支持播放视频，请使用Chrome浏览器或IE最新版本打开
                </video>
                <img src="../../../static/images/2018120501.jpg" width="80%" alt=""/>
                <img src="../../../static/images/2018120502.jpg" width="80%" alt=""/>
                <img src="../../../static/images/20181205021.jpg" width="80%" alt=""/>
                <img src="../../../static/images/2018120503.jpg" width="80%" alt=""/>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '阅读推广与图书漂流中心', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '阅读推广与图书漂流中心'
        },
        {
            name: 'description',
            content: '阅读推广与图书漂流中心'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'2',
            blackTabsNum:'5'
        }
    },
    methods: {
        topback(){
            window.localStorage.setItem('blackTabsNum',5)
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/old/ydtg.vue